import React, { useState,  forwardRef,  useImperativeHandle } from "react";


const IntValRenderer = forwardRef((props, ref) => {
   const [val, setVal] = useState(props.value);
       
       useImperativeHandle(ref, () => {
           return {
               refresh(params) {
                   var val = props.getValue();
                   if (val !== undefined) {
                       setVal(val.toString());
                   }
               }
           };
       });
       return <span className="editableCell">{val && val != "" ? val : <div><span className="addtext"></span><div className="addtextafter">...</div></div>}</span>
});

export default IntValRenderer;

